// extracted by mini-css-extract-plugin
module.exports = {"container":"barcodepdf_container__26IpO","content":"barcodepdf_content__CZGTw"};